import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { AdUnitViewabilityToolsAlert } from 'features/globalSetup/api/types/adUnitViewabilityToolsAlert'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'
import { AdUnitViewabilityTools } from '../../types/AdUnitViewabilityTools'

type Props = {
  alerts: AdUnitViewabilityTools['alerts']
}

export const ViewabilityToolsAlerts = ({ alerts }: Props): React.JSX.Element => {
  const theme = useTheme()

  const UnpluggedAlert = (alert: Alert<AdUnitViewabilityToolsAlert>): AlertData => ({
    color: theme.palette.warning.main,
    Icon: (
      <SvgIcon
        component={UnpluggedIcon}
        inheritViewBox
      />
    ),
    tooltip: { text: alert.description },
  })

  const switcher = (alert: Alert<AdUnitViewabilityToolsAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'adHoldingEnabled':
        return UnpluggedAlert(alert)

      case 'lazyLoadingEnabled':
        return UnpluggedAlert(alert)

      case 'scrollSlowingEnabled':
        return UnpluggedAlert(alert)

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<AdUnitViewabilityToolsAlert> {...{ alerts, switcher }} />
}
